import React from 'react';
import userConfig from '../../../config';

import Container from '../Container';
import HeaderImage from '../HeaderImage';
import H3 from '../H3';
import Link from './Link';
import Wrapper from './Wrapper';

function MainHeader({ config }) {
  const { author, description, social } = config;

  return (
    <Container>
      <Wrapper>
        {userConfig.showHeaderImage && (
          <HeaderImage/>
        )}
        <H3><Link to="/">A website exploring the relationship between mythology and the Matrix film franchise by {author}</Link></H3>
      </Wrapper>
    </Container> 
  );
}

export default MainHeader;